"use strict";
/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getContinuationToken = getContinuationToken;
exports.setContinuationToken = setContinuationToken;
const pageMap = new WeakMap();
/**
 * Given a result page from a pageable operation, returns a
 * continuation token that can be used to begin paging from
 * that point later.
 * @param page A result object from calling .byPage() on a paged operation.
 * @returns The continuation token that can be passed into byPage().
 */
function getContinuationToken(page) {
    if (typeof page !== "object" || page === null) {
        return undefined;
    }
    return pageMap.get(page)?.continuationToken;
}
function setContinuationToken(page, continuationToken) {
    if (typeof page !== "object" || page === null || !continuationToken) {
        return;
    }
    const pageInfo = pageMap.get(page) ?? {};
    pageInfo.continuationToken = continuationToken;
    pageMap.set(page, pageInfo);
}
//# sourceMappingURL=pagingHelper.js.map